import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { AccountInput } from 'generated/graphql-types';
import { Observable, of } from 'rxjs';
import { AccountDetailSaveModel } from '../models/account-detail-save.model';
import { getAccountDetail } from '../queries/account-detail.graphql';
import { GetAccountDetail, GetAccountDetailVariables } from '../queries/generated/GetAccountDetail';
import { SaveAccount, SaveAccountVariables } from '../queries/generated/SaveAccount';
import { SaveAccountMutation } from '../queries/save-account.graphql';

@Injectable({ providedIn: 'root' })
export class AccountDetailApiService {
   constructor(private apiService: LcsApiService, private http: HttpClient) {}

   save(
      accountDetail: AccountDetailSaveModel,
      fields: (keyof AccountInput)[]
   ): Observable<ExecutionResult<SaveAccount>> {
      let deletedNoteId =
         accountDetail.note && !accountDetail.note.notes && accountDetail.note.noteId !== 0
            ? accountDetail.note.noteId
            : undefined;

      if (fields.includes('isCallRecordingFeatureEnabled') && accountDetail.isCallRecordingFeatureEnabled === false) {
         const dependentFields: (keyof AccountInput)[] = [
            'isRecordInboundCalls',
            'isRecordOutboundCalls',
            'isRecordInternalCalls',
            'isOtrEnabled',
         ];

         fields = Array.from(new Set([...fields, ...dependentFields]));
      }
      const accountNotesFieldIndex = fields.indexOf('note');
      if (accountNotesFieldIndex !== -1) {
         if (fields.length === 1 && fields[0] === 'note') {
            fields = [];
         } else {
            fields = [...fields];
            fields.splice(accountNotesFieldIndex, 1);
         }
         if (deletedNoteId === undefined) {
            this.formatEmbeddedNoteFields(fields);
         } else {
            if (fields.length === 0) {
               fields.push('accountId');
            }
         }
      }

      return this.apiService.query<SaveAccount, SaveAccountVariables>({
         query: SaveAccountMutation,
         variables: {
            deletedNoteIds: deletedNoteId ? [deletedNoteId] : [],
            hasDeletedNotes: deletedNoteId !== undefined,
            account: {
               ...accountDetail,
               fields: fields,
            },
         },
      });
   }

   formatEmbeddedNoteFields(fields: string[]) {
      fields.push(
         ...noteFields.map((keyField) => {
            return `note.${keyField}`;
         })
      );
   }

   savePresenceCredentials(accountId: number, username: string, password: string, fields: string[]) {
      if (!fields || fields.length == 0) return of(new HttpResponse({ body: accountId }));
      const account = {
         accountId: accountId,
         presenceUser: username,
         presencePassword: password,
      };
      let fieldsuri = '?fields=' + fields.join(',');
      return this.http.post<number>(`${this.apiService.apiUrl}/Accounts/SavePresenceCredentials${fieldsuri}`, account, {
         observe: 'response',
      });
   }

   getAccountDetails(accountId: number): Observable<ExecutionResult<GetAccountDetail>> {
      const variables: GetAccountDetailVariables = {
         id: accountId,
      };

      return this.apiService.query<GetAccountDetail, GetAccountDetailVariables>({
         query: getAccountDetail,
         variables: variables,
      });
   }

   rebootAllPhones(accountId: number): Observable<void> {
      const devicePostBody = {
         AccountId: accountId,
      };
      return this.http.post<void>(`${this.apiService.apiUrl}/Devices/RebootAccountPhones`, devicePostBody);

      // TODO: if we can get tasks working w/ graphql
      // return this.apiService.query<RebootAccountPhones, RebootAccountPhonesVariables>({
      //    query: rebootAccountPhones,
      //    variables: {
      //       accountId,
      //    },
      // });
   }
}

export const noteFields: string[] = ['noteId', 'accountId', 'notes', 'isSystemNote'];
